var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cross_border_container"},[_vm._v(" 获得海关批准的商业快件运营人资质，在全国各地展开跨境电商模式的清关服务，已成为专业的跨境电商物流企业。公司自主开发的推单系统在强大的IT团队的努力下，完成日常的推送运维工作，确保客户提供数据与海关申报系统稳定对接。 ")])}
var staticRenderFns = []

export { render, staticRenderFns }